<template>
  <div class="user-avatar">
    <div
      class="
        rounded-circle
        d-flex
        justify-content-center
        align-items-center
        bg-secondary
      "
    >
      <!-- <span>{{ userInitials }}</span> -->
      <span class="material-icons"> person </span>
      <div class="profile-menu shadow-sm">
        <ul class="text-nowrap">
          <li>
            <div class="profile-info">
              <p class="mb-1 fw-bold font-caps">{{ fullname }}</p>
              <p class="mb-0 text-secondary small">{{ user.email }}</p>
            </div>
          </li>
          <li>
            <hr />
          </li>
          <li>
            <router-link :to="{ name: 'profile.settings' }"
              >პროფილი</router-link
            >
          </li>
          <li>
            <router-link :to="{ name: 'profile.certificate' }"
              >სერტიფიკატი</router-link
            >
          </li>
          <li>
            <hr />
          </li>
          <template v-if="routeName != 'section'">
            <li v-if="step == 1">
              <router-link :to="{ name: 'section', params: { id: 1 } }"
                >კურსის დაწყება</router-link
              >
            </li>
            <li v-else>
              <router-link :to="{ name: 'section', params: { id: step } }"
                >კურსის გაგრძელება</router-link
              >
            </li>
            <li>
              <hr />
            </li>
          </template>
          <li>
            <router-link :to="{ name: 'signout' }">გასვლა</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watchEffect } from "@vue/runtime-core";
import { useStore } from "vuex";
import useFullname from "@/composables/useFullname";
import useUserInitials from "@/composables/useUserInitials";
export default {
  props: ["routeName"],
  setup() {
    const fullname = ref();
    const userInitials = ref();

    const store = useStore();
    const user = computed(() => {
      return store.state.user;
    });

    const step = computed(() => {
      return store.getters.step;
    });

    watchEffect(() => {
      fullname.value = useFullname(user.value.firstname, user.value.lastname);
      userInitials.value = useUserInitials(
        user.value.firstname,
        user.value.lastname
      );
    });

    return { user, fullname, userInitials, step };
  },
};
</script>

<style>
.user-avatar > div {
  width: 36px;
  height: 36px;
  /* background-color: #3d5a80; */
  margin: 0 1rem;
  cursor: pointer;
  position: relative;
}
.user-avatar span {
  color: #fff;
}
.user-avatar .profile-menu {
  position: absolute;
  top: 100%;
  right: 0;
  padding-top: 5px;
  display: none;
  z-index: 99;
}
.user-avatar:hover .profile-menu {
  display: block;
}
.user-avatar .profile-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  border: solid 1px #dbdfe3;
  background-color: #fff;
}
.user-avatar .profile-menu ul li a {
  color: inherit;
  text-decoration: none;
  display: block;
  padding: 0 1.8rem 0.8rem 1.8rem;
}
.user-avatar .profile-menu ul li a:hover {
  color: #4460ca;
}
.user-avatar .profile-menu ul li hr {
  border-top: solid 1px #dbdfe3;
  margin: 0;
  padding: 0;
  opacity: 1;
  padding: 0 0 0.8rem 0;
}
.user-avatar .profile-menu ul li .profile-info {
  cursor: default;
  padding: 0.8rem 1.8rem;
}
</style>